import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export function TaxonomyPicker({ value, onChange, testid = "taxonomy" }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get("/admin/merchant/taxonomy", { params: { q } }).then((r) => setRes(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="relative">
      <div className="flex gap-2 items-center">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={value ? `Mapped: ${value} — search to change` : "Search Google taxonomy (e.g. barcode, 139)"} className="h-9" data-testid={`${testid}-search`} />
        {value ? <button type="button" className="text-xs text-red-600 whitespace-nowrap" onClick={() => onChange(null)} data-testid={`${testid}-clear`}>Clear</button> : null}
      </div>
      {res.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-60 overflow-y-auto rounded-md border bg-white shadow-lg text-xs" data-testid={`${testid}-results`}>
          {res.map((r) => (
            <button type="button" key={r.id} className="block w-full text-left px-2 py-1.5 hover:bg-slate-100" onClick={() => { onChange(r.id); setQ(""); setRes([]); }} data-testid={`${testid}-opt-${r.id}`}>
              <b>{r.id}</b> · {r.path}
            </button>))}
        </div>)}
    </div>
  );
}
